import Vue from "vue";
import Component from "vue-class-component";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";

@Component({ name: "DownloadLimitReached" })
export default class DownloadLimitReached extends Vue {
    public localizer: any = Localizer;
    public isVisible: boolean = false;
    public isLoading: boolean = false;
    public isSuccess: boolean = false;
    public validationErrors: any[] = [];

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        if (this.$route.query.hasOwnProperty("DownloadLimitReached")) {
            this.isVisible = true;
        }
    }

    public async sendRequest() {
        FormHelper.removeFocus();
        this.validationErrors = [];
        this.isLoading = true;

        try {
            await Axios.post(this.routes.DigitalCatalogue_Catalogue_CatalogueRequest, null);

            this.isSuccess = true;
        } catch (error) {
            if (error.response && error.response.status === 400) {
                this.validationErrors = FormHelper.getValidationErrors(error.response.data);
            }
        }

        this.isLoading = false;
    }

    public backNavigation() {
        window.location.href = window.location.origin + window.location.pathname;
    }
}